// Thanks to https://github.com/kay999/vue-constants
import Vue from 'vue';

const install = () => {
  Vue.mixin({
    beforeCreate() {
      const { constants } = this.$options;
      if (!constants) {
        return;
      }

      Object.entries(constants).forEach(
        ([key, value]) => {
          this[key] = value;
        },
      );
    },
  });
};

export default { install };
